module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-bar-up-f0ec2dd4.svg";